function formatDate (date) {
  return (new Date(date)).toLocaleDateString()
}

export function featuresToHTML (config, dataset, features, datasetInfos) {
  const parcelle = features.find(f => f.properties.class === 'parcelle')
  const batiment = features.find(f => f.properties.class === 'batiment')

  let html = ''
  if (datasetInfos && config.tooltip.length) {
    html += '<h3>Informations</h3>'
    dataset.schema.filter(field => config.tooltip.indexOf(field.key) >= 0).forEach(field => {
      html += `<p><span class="md-caption">${field.title || field['x-originalName']} :</span>  ${datasetInfos[field.key] || ''}</p>`
    })
  }

  let parcelHtml = ''
  if (parcelle && (!config.hideParcelsInfos || !datasetInfos)) {
    parcelHtml += '<h3>Parcelle</h3>'
    parcelHtml += `<p><span class="md-caption">Section :</span>  ${parcelle.properties.section}</p>`
    parcelHtml += `<p><span class="md-caption">Numéro :</span>  ${parcelle.properties.numero}</p>`
    if (parcelle.properties.contenance) {
      parcelHtml += `<p><span class="md-caption">Contenance :</span>  ${parcelle.properties.contenance.toLocaleString()} m²</p>`
    }
    parcelHtml += `<p><span class="md-caption">Créée le :</span>  ${formatDate(parcelle.properties.created)}</p>`
    parcelHtml += `<p><span class="md-caption">Mise à jour le</span>  : ${formatDate(parcelle.properties.updated)}</p>`
  }

  let batimentHtml = ''
  if (batiment && (!config.hideBuildingInfos || !datasetInfos)) {
    batimentHtml += '<h3>Bâtiment</h3>'
    batimentHtml += `<p><span class="md-caption">Créé le :</span>  ${formatDate(batiment.properties.created)}</p>`
    batimentHtml += `<p><span class="md-caption">Mis à jour le</span>  : ${formatDate(batiment.properties.updated)}</p>`
    batimentHtml += `<p><span class="md-caption">Type de bâti</span>  : ${batiment.properties.type === '01' ? 'dur' : 'léger'}</p>`
  }
  return Promise.resolve(html + parcelHtml + batimentHtml)
}

export function resizeBBOX (bbox, ratio) {
  const d1 = bbox[2] - bbox[0]
  const d1diff = ((d1 * ratio) - d1) / 2
  const d2 = bbox[3] - bbox[1]
  const d2diff = ((d2 * ratio) - d2) / 2
  return [Math.max(bbox[0] - d1diff, -180), Math.max(bbox[1] - d2diff, -90), Math.min(bbox[2] + d1diff, 180), Math.min(bbox[3] + d2diff, 90)]
}

export function bboxIncluded (bbox1, bbox2) {
  return bbox1[0] >= bbox2[0] && bbox1[1] >= bbox2[1] && bbox1[2] <= bbox2[2] && bbox1[3] <= bbox2[3]
}

export const colors = ['#2196F3', '#E91E63', '#7E57C2', '#009688', '#00BCD4', '#EF6C00', '#4CAF50', '#FF9800', '#F44336', '#CDDC39', '#9C27B0', '#FFC107', '#3F51B5', '#795548', '#607D8B', '#FF9800', '#03A9F4', '#8BC34A', '#FFEB3B']

export function bbox2zoom (bbox) {
  const latDiff = bbox[3] - bbox[1]
  const lngDiff = bbox[2] - bbox[0]
  const maxDiff = (lngDiff > latDiff) ? lngDiff : latDiff
  let zoomLevel
  if (maxDiff < 360 / Math.pow(2, 20)) {
    zoomLevel = 21
  } else {
    zoomLevel = -1 * ((Math.log(maxDiff) / Math.log(2)) - (Math.log(360) / Math.log(2)))
    if (zoomLevel < 1) zoomLevel = 1
  }
  return zoomLevel
}
